/* eslint-disable react/no-array-index-key */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-conditional */
/* eslint-disable react/prop-types */
/* eslint-disable max-lines */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/* eslint-disable react/boolean-prop-naming */
/* eslint-disable max-len */
/* eslint-disable no-lonely-if */
/* eslint-disable no-magic-numbers */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import { createRef, lazy, Suspense } from 'react';

import Breadcrumbs from 'Component/Breadcrumbs';
import CategoryItemsCount from 'Component/CategoryItemsCount';
import CategoryProductList from 'Component/CategoryProductList';
import CategorySort from 'Component/CategorySort';
import { DESKTOP_MIN_WIDTH, EXTRA_LARGE_DESKTOP_MIN_WIDTH } from 'Component/CategorySort/CategorySort.config';
import ContentWrapper from 'Component/ContentWrapper';
import Loader from 'Component/Loader';
import MenuFilters from 'Component/MenuFilters';
import SelectedFilters from 'Component/SelectedFilters';
import TextPlaceholder from 'Component/TextPlaceholder';
import { SCROLL_TO_TOP_TIMEOUT } from 'Route/CategoryPage/CategoryPage.config';
import { CategoryPage as SourceCategoryPage } from 'SourceRoute/CategoryPage/CategoryPage.component';
import { HistoryType, LocationType } from 'Type/Router.type';
import { isCrawler, isSSR } from 'Util/Browser';
import { handleIosStickyHeader } from 'Util/PromoBanner/PromoBanner';

import './CategoryPage.style';
import './CategoryPage.style.extended.scss';

export const ScrollToTopButton = lazy(() => import(/* webpackMode: "lazy", webpackChunkName: "footer" */ 'Component/ScrollToTopButton/ScrollToTopButton.component'));
export const Html = lazy(() => import(/* webpackMode: "lazy", webpackChunkName: "cms" */ 'Component/Html'));
export const CategoryFilterOverlay = lazy(() => import(/* webpackMode: "lazy", webpackChunkName: "filters" */ 'Component/CategoryFilterOverlay'));

/** @namespace Scandipwa/Route/CategoryPage/Component */
export class CategoryPageComponent extends SourceCategoryPage {
    static propTypes = {
        ...super.propTypes,
        toggleOverlayByKey: PropTypes.func.isRequired,
        location: LocationType.isRequired,
        history: HistoryType.isRequired,
        sortKey: PropTypes.string.isRequired,
        sortDirection: PropTypes.string.isRequired,
        isInfoLoading: PropTypes.bool.isRequired,
        requestCategoryFromFilters: PropTypes.func.isRequired,
        activeOverlay: PropTypes.string,
        isNavOnTop: PropTypes.bool.isRequired,
        isSearchPage: PropTypes.bool.isRequired,
        baseUrl: PropTypes.string,
        onMoreFiltersClick: PropTypes.func.isRequired,
        showMoreFilters: PropTypes.bool.isRequired,
        showPopup: PropTypes.func.isRequired
    };

    static defaultProps = {
        ...super.defaultProps,
        activeOverlay: undefined,
        baseUrl: ''
    };

    state = {
        isScrollToTopButtonRender: false,
        isDesktop: false,
        isExtraLargeDesktop: false,
        topDetailsHeight: undefined,
        filterWrappersHeight: undefined,
        prevFilterWrappersHeight: undefined,
        menuFiltersHeight: undefined,
        categoryFiltersHeight: undefined,
        sizeFiltersHeight: undefined,
        areMobileFiltersOpen: false,
        isMiscellaneousRendered: false,
        previousGenderFilter: {}, // if this is to be applied to all filters, BE solution would be better.
        isScrollFrozen: false
    };

    topDetailsRef = createRef();

    filtersRef = createRef();

    filtersInnerWrapperPlaceholderRef = createRef();

    lastScroll = 0;

    onFilterButtonClick = this.onFilterButtonClick.bind(this);

    updateWindowDimensions = this.updateWindowDimensions.bind(this);

    onHeightUpdate = this.onHeightUpdate.bind(this);

    renderSelectedFilters = this.renderSelectedFilters.bind(this);

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        handleIosStickyHeader();

        window.addEventListener('scroll', this.handleStickyFilters);
        this.freezeScroll();
    }

    componentDidUpdate(prevProps) {
        const { filter: prevFilter } = prevProps;
        const { filter: currFilter } = this.props;

        if (JSON.stringify(currFilter) !== JSON.stringify(prevFilter) && this.topDetailsRef.current) {
            this.topDetailsRef.current.scrollIntoView({ behavior: 'smooth' });
            document.body.style.overflow = 'hidden';
            setTimeout(() => {
                document.body.style.overflow = 'initial';
            }, SCROLL_TO_TOP_TIMEOUT);
        }

        const { isDesktop } = this.state;

        if (isDesktop) {
            const { filterWrappersHeight, topDetailsHeight } = this.state;

            if (this.topDetailsRef.current && topDetailsHeight !== this.topDetailsRef.current.clientHeight) {
                this.setTopDetailsHeight(this.topDetailsRef.current.clientHeight);
            }

            if (this.filtersRef.current && filterWrappersHeight !== this.filtersRef.current.clientHeight) {
                this.setFilterWrappersHeight(this.filtersRef.current.clientHeight);
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
        window.removeEventListener('scroll', this.handleStickyFilters);
        this.unfreezeScroll();
    }

    freezeScroll() {
        const { isMobile } = this.props;

        if (isMobile && window.backButtonFromPDP) {
            document.body.style.overflow = 'hidden';
            window.backButtonFromPDP = false;
            this.setState({ isScrollFrozen: true });
            setInterval(() => {
                this.unfreezeScroll();
            }, 1500);
        }
    }

    unfreezeScroll() {
        document.body.style.overflow = 'initial';
        this.setState({ isScrollFrozen: false });
    }

    resetAreMobileFiltersOpen = () => {
        this.setState({ areMobileFiltersOpen: false });
    };

    onFilterButtonClick() {
        const { showPopup, totalItems, selectedFilters } = this.props;

        showPopup({
            title: __('Filters'),
            totalItems,
            selectedFilters
        });

        this.setState({ areMobileFiltersOpen: true });
    }

    updateWindowDimensions() {
        const { isDesktop, isExtraLargeDesktop } = this.state;
        const newIsDesktop = (window.innerWidth >= DESKTOP_MIN_WIDTH);
        const newIsExtraLargeDesktop = (window.innerWidth >= EXTRA_LARGE_DESKTOP_MIN_WIDTH);

        if (isDesktop !== newIsDesktop) {
            this.setState({ isDesktop: newIsDesktop });
        }

        if (isExtraLargeDesktop !== newIsExtraLargeDesktop) {
            this.setState({ isExtraLargeDesktop: newIsExtraLargeDesktop });
        }
    }

    setTopDetailsHeight = (value) => {
        this.setState({ topDetailsHeight: value });
    };

    setFilterWrappersHeight = (value) => {
        const { filterWrappersHeight } = this.state;
        this.setState({
            filterWrappersHeight: value,
            prevFilterWrappersHeight: filterWrappersHeight
        });
    };

    setMenuFiltersHeight = (value) => {
        this.setState({ menuFiltersHeight: value });
    };

    setCategoryFiltersHeight = (value) => {
        this.setState({ categoryFiltersHeight: value });
    };

    setSizeFiltersHeight = (value) => {
        this.setState({ sizeFiltersHeight: value });
    };

    setIsMiscellaneousRendered = (value) => {
        this.setState({ isMiscellaneousRendered: value });
    };

    renderSelectedFilters() {
        const { selectedInfoFilter, filters } = this.props;

        return (
            <SelectedFilters
              selectedFilters={ selectedInfoFilter }
              availableFilters={ filters }
            />
        );
    }

    renderMiscellaneous() {
        const { isMatchingListFilter, isInfoLoading } = this.props;
        const { isDesktop, isMiscellaneousRendered } = this.state;

        if ((!isMatchingListFilter || isInfoLoading) && !isDesktop && !isMiscellaneousRendered) {
            return (
                <>
                    <div block="CategoryPage" elem="FilterPlaceHolder">
                        <TextPlaceholder content={ false } length="medium" />
                    </div>
                    <div block="CategoryPage" elem="SortPlaceHolder">
                        <TextPlaceholder content={ false } length="medium" />
                    </div>
                </>
            );
        }

        if (!isMiscellaneousRendered) {
            this.setIsMiscellaneousRendered(true);
        }

        if (!isDesktop) {
            return (
                <div block="CategoryPage" elem="FilterButtonWrapper">
                    { this.renderFilterButton() }
                    { this.renderCategorySort() }
                    { this.renderSelectedFilters() }
                </div>
            );
        }

        return (
            <>
                <div
                  block="CategoryPage"
                  elem="FilterWrapper"
                  ref={ this.filtersRef }
                >
                        <div block="CategoryPage" elem="FilterInnerWrapperPlaceholder" ref={ this.filtersInnerWrapperPlaceholderRef } />
                        { this.renderFilterInnerWrapper() }
                </div>
                { this.renderMoreFiltersButton() }
                { this.renderCategorySort() }
            </>
        );
    }

    handleStickyFilters = () => {
        const { isMobile } = this.props;
        const { areMobileFiltersOpen } = this.state;

        const stickyClass = 'CategoryPage-Miscellaneous_is_Sticky';
        const stickyFilters = document.getElementsByClassName('CategoryPage-Miscellaneous')[0];
        const { pageYOffset: currentScroll } = window;

        if (currentScroll < this.lastScroll || !isMobile) {
            stickyFilters.classList.add(stickyClass);
        } else if (currentScroll > this.lastScroll && !areMobileFiltersOpen && isMobile) {
            stickyFilters.classList.remove(stickyClass);
        }

        this.lastScroll = currentScroll;
    };

    onHeightUpdate() {
        const {
            prevFilterWrappersHeight
        } = this.state;
        const {
            current: {
                clientHeight
            } = {}
        } = this.filtersRef;

        if (clientHeight !== prevFilterWrappersHeight) {
            CSS.setVariable(
                this.filtersInnerWrapperRef,
                'filter-wrapper-top',
                'calc(var(--header-height) - 400px)'
            );
        }
    }

    renderFilterInnerWrapper() {
        const {
            isDesktop,
            areMobileFiltersOpen
        } = this.state;

        const { isNavOnTop } = this.props;

        if (!isDesktop && !areMobileFiltersOpen) {
            return null;
        }

        return (
                <div
                  block="CategoryPage"
                  elem="FilterInnerWrapper"
                >
                    { isNavOnTop ? this.renderMenuFilters() : this.renderFilterOverlay() }
                    { isNavOnTop ? this.renderFilterOverlay() : this.renderMenuFilters() }
                </div>
        );
    }

    renderMiscDesktopPlaceholder() {
        return (
            <TextPlaceholder content={ false } length="medium" />

        );
    }

    renderContent() {
        const { isMatchingListFilter, isInfoLoading } = this.props;
        const { isMiscellaneousRendered } = this.state;
        const isLoading = (!isMatchingListFilter && !isMiscellaneousRendered) || isInfoLoading;

        return (
            <>
                <aside
                  block="CategoryPage"
                  elem="Miscellaneous"
                >
                    { isLoading ? this.renderMiscDesktopPlaceholder() : this.renderMiscellaneous() }
                </aside>
                { this.renderSelectedFilters() }
                { this.renderItemsCount() }
                { this.renderCategoryProductList() }
            </>
        );
    }

    renderMoreFiltersButton() {
        const {
            showMoreFilters,
            onMoreFiltersClick,
            isInfoLoading,
            filters
        } = this.props;

        const isSearch = /search/.test(window.location.pathname);

        if (isSearch || (!isInfoLoading && Object.keys(filters).length <= 1)) {
            return null;
        }

        return (
            <div
              role="button"
              block="CategoryPage"
              elem="MoreFiltersButton"
              onClick={ onMoreFiltersClick }
            >
                { showMoreFilters ? __('- Less Filters') : __('+ More Filters') }
            </div>
        );
    }

    renderContentMobile() {
        const { isMatchingListFilter, isInfoLoading } = this.props;
        const { isMiscellaneousRendered } = this.state;
        const isLoading = (!isMatchingListFilter && !isMiscellaneousRendered) || isInfoLoading;

        return (
            <>
                <aside
                  block="CategoryPage"
                  elem="Miscellaneous"
                  mods={ { isLoading } }
                >
                    { this.renderMiscellaneous() }
                    <div
                      block="CategoryPage"
                      elem="FilterWrapper"
                      ref={ this.filtersRef }
                    >
                        <div block="CategoryPage" elem="FilterInnerWrapperPlaceholder" ref={ this.filtersInnerWrapperPlaceholderRef } />
                        { this.renderFilterInnerWrapper() }
                    </div>
                </aside>

                { this.renderItemsCount() }
                { this.renderCategoryProductList() }
            </>
        );
    }

    renderMenuFilters() {
        const {
            category,
            history,
            isMatchingInfoFilter,
            isInfoLoading,
            requestCategoryFromFilters,
            isSearchPage,
            showMoreFilters
        } = this.props;
        const { menuFiltersHeight } = this.state;

        if (!showMoreFilters) {
            return null;
        }

        return (
            <MenuFilters
              category={ category }
              history={ history }
              menuFiltersHeight={ menuFiltersHeight }
              setMenuFiltersHeight={ this.setMenuFiltersHeight }
              isMatchingInfoFilter={ isMatchingInfoFilter }
              areComponentsLoading={ isInfoLoading && !isMatchingInfoFilter }
              requestCategoryFromFilters={ requestCategoryFromFilters }
              isSearchPage={ isSearchPage }
            />
        );
    }

    renderFilterOverlay() {
        const {
            selectedFilters,
            isMatchingInfoFilter,
            isInfoLoading,
            history,
            location
        } = this.props;

        const {
            categoryFiltersHeight,
            sizeFiltersHeight
        } = this.state;

        return (
            <Suspense fallback={ null }>
                <CategoryFilterOverlay
                  availableFilters={ this.getAvailableFilters() }
                  customFiltersValues={ selectedFilters }
                  isMatchingInfoFilter={ isMatchingInfoFilter }
                  sizeFiltersHeight={ sizeFiltersHeight }
                  setSizeFiltersHeight={ this.setSizeFiltersHeight }
                  categoryFiltersHeight={ categoryFiltersHeight }
                  setCategoryFiltersHeight={ this.setCategoryFiltersHeight }
                  areComponentsLoading={ isInfoLoading && !isMatchingInfoFilter }
                  onPopupHide={ this.resetAreMobileFiltersOpen }
                  history={ history }
                  location={ location }
                />
            </Suspense>
        );
    }

    getAvailableFilters() {
        const {
            filters,
            filters: { gender }
        } = this.props;

        const {
            previousGenderFilter,
            previousGenderFilter: { attribute_options: prev_attribute_options_ }
        } = this.state;

        if (gender) {
            if (prev_attribute_options_) {
                // eslint-disable-next-line max-len
                if (Object.keys(gender.attribute_options).length >= Object.keys(previousGenderFilter.attribute_options).length) {
                    this.setState({ previousGenderFilter: gender });
                } else {
                    // eslint-disable-next-line no-param-reassign
                    filters.gender = previousGenderFilter;
                }
            } else {
                this.setState({ previousGenderFilter: gender });
            }
        }

        return filters;
    }

    renderCategoryProductList() {
        const {
            filter,
            search,
            selectedSort,
            selectedFilters,
            isMatchingListFilter,
            isInfoLoading,
            isCurrentCategoryLoaded,
            isMatchingInfoFilter
        } = this.props;

        return (
            <div
              block="CategoryPage"
              elem="ProductListWrapper"
              mods={ { isPrerendered: isSSR() || isCrawler() } }
            >
                <CategoryProductList
                  filter={ filter }
                  search={ search }
                  sort={ selectedSort }
                  selectedFilters={ selectedFilters }
                  isMatchingListFilter={ isMatchingListFilter }
                  isMatchingInfoFilter={ isMatchingInfoFilter }
                  isCurrentCategoryLoaded={ isCurrentCategoryLoaded }
                  areComponentsLoading={ isInfoLoading && !isMatchingListFilter }
                />
            </div>
        );
    }

    renderContentBlockPlaceholder() {
        return <div block="CategoryPage" elem="ContentBlockPlaceholder" />;
    }

    renderContentBlocks() {
        const { category: { content_blocks, id, hide_products } } = this.props;

        if (!id) {
            this.renderContentBlockPlaceholder();
        }

        if (!content_blocks) {
            return null;
        }

        const { top_content } = content_blocks;

        if (!top_content || !top_content.length) {
            return null;
        }

        if (hide_products) {
            top_content.length = 1;
        }

        return top_content.map((block, index) => (
            <Suspense
              key={ index }
              fallback={ this.renderContentBlockPlaceholder() }
            >
                <Html key={ block.id } content={ block } />
            </Suspense>
        ));
    }

    renderFilterButton() {
        const { selectedFilters } = this.props;

        // eslint-disable-next-line fp/no-let
        let appliedFiltersCount = 0;

        if (selectedFilters) {
            Object.values(selectedFilters).forEach((filterArray) => {
                appliedFiltersCount += filterArray.length;
            });
        }

        return (
            <button
              block="CategoryPage"
              elem="Filter"
              onClick={ this.onFilterButtonClick }
            >
                { __('Filters') }
                <div block="Icon" elem="Filter" />
                { __('(%s)', appliedFiltersCount) }
            </button>
        );
    }

    renderCategorySort() {
        const {
            sortFields,
            selectedSort,
            onSortChange,
            isMatchingInfoFilter,
            sortKey: configSortKey,
            sortDirection: configSortDirection,
            location,
            isInfoLoading,
            category: {
                default_sort_by
            },
            isCurrentCategoryLoaded
        } = this.props;

        const { options = {} } = sortFields;
        const updatedSortFields = Object.values(options).map(({ value: id, label }) => ({ id, label }));
        const { sortDirection, sortKey } = selectedSort;

        return (
            <CategorySort
              isCurrentCategoryLoaded={ isCurrentCategoryLoaded }
              isMatchingInfoFilter={ isMatchingInfoFilter }
              onSortChange={ onSortChange }
              sortFields={ updatedSortFields }
              sortKey={ sortKey }
              sortDirection={ sortDirection }
              config={ [configSortKey, configSortDirection] }
              location={ location }
              areComponentsLoading={ isInfoLoading && !isMatchingInfoFilter }
              default_sort_by={ default_sort_by }
            />
        );
    }

    renderItemsCount() {
        const { isMatchingListFilter } = this.props;

        return (
            <CategoryItemsCount
              isMatchingListFilter={ isMatchingListFilter }
            />
        );
    }

    render() {
        const logoUrl = window.publicPath === undefined ? '/assets/images/global/puma-og-logo.png'
            : `${window.location.origin}${window.publicPath}assets/images/global/puma-og-logo.png`;
        const { isScrollToTopButtonRender, isScrollFrozen } = this.state;

        const {
            category: { id, hide_products },
            isInfoLoading,
            isMatchingListFilter,
            baseUrl,
            isMobile
        } = this.props;

        const hideProducts = typeof hide_products === 'undefined' || hide_products === 1;

        return (
            <>
                { !hideProducts && (<Breadcrumbs />) }
                <main
                  block="CategoryPage"
                  itemScope
                  itemType="http://schema.org/Organization"
                >
                    <Loader isLoading={ isScrollFrozen } />
                    { isScrollToTopButtonRender && <Suspense fallback={ null }><ScrollToTopButton /></Suspense> }
                    <meta itemProp="url" content={ baseUrl } />
                    <meta itemProp="logo" content={ logoUrl } />
                    <div
                      block="CategoryPage"
                      elem="Header ContentWrapper"
                      mods={ { isLoading: (isInfoLoading && !isMatchingListFilter && !hideProducts) || !id } }
                    >
                        { this.renderContentBlocks() }
                    </div>
                    { !hideProducts && (
                            <div block="CategoryPage" elem="TopDetails" ref={ this.topDetailsRef }>
                                { this.renderCategoryDetails() }
                            </div>
                    ) }
                    { !hideProducts && (
                        <ContentWrapper
                          wrapperMix={ {
                              block: 'CategoryPage',
                              elem: 'Wrapper'
                          } }
                          label="Category page"
                        >
                            { isMobile ? this.renderContentMobile() : this.renderContent() }
                        </ContentWrapper>
                    ) }
                </main>
            </>
        );
    }
}

export default CategoryPageComponent;
